import { render, staticRenderFns } from "./Cimage.vue?vue&type=template&id=33e51061&scoped=true"
import script from "./Cimage.vue?vue&type=script&lang=js"
export * from "./Cimage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e51061",
  null
  
)

export default component.exports